import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Image } from 'semantic-ui-react';

import IclusigLogo from '../IclusigLogo';

const Header = props => {
  let isCaseManagers = false;
  // used to hide the product selected on the header
  if (window.location.pathname.includes('casemanagers')) {
    isCaseManagers = true;
  }

  // Check if URL contains enroll/eligibility
  const hasEnrollEligibility = window.location.pathname.includes('enroll/eligibility');

  // Show environment-selected divs unless it's casemanagers with enroll/eligibility
  const shouldShowEnvironment = !props.isHome && props.environment && !(isCaseManagers && hasEnrollEligibility);

  return (
    <header className={ `header full-width ${props.isHome ? 'home-header' : ''}` }>
      <div className={ `wrapper ${!(isCaseManagers && hasEnrollEligibility) && !props.isHome && props.environment === 'iclusig' ? 'iclusig-header' : ''}` }>
        <div>
          <Link
            className="track track-1 track-env-global"
            to="/"
            onClick={ props.onClick }
          >
            <img className="takeda-logo" src="/images/takeda_oncology_here2assist_logo.png" alt="Takeda Oncology Here2Assist logo" />
          </Link>
          { shouldShowEnvironment && props.environment !== 'iclusig'
            ? (
              <div className="environment-selected">
                <i className="arrow right" />
                <Image className={ props.environment } src={ `/images/${props.environment.toUpperCase()}_logo.svg` } alt={ props.environment } />
              </div>
            )
            : '' }
          { shouldShowEnvironment && (props.environment === 'iclusig')
            ? (
              <div className="environment-selected">
                <i className="arrow right" />
                <IclusigLogo
                  imgLink = { props.environment }
                  verticalAlign="middle"
                />
              </div>
            )
            : '' }
        </div>
        <p className="header-callout"><strong className="poppins-bold">We’re here to help.</strong> Call 1-844-817-6468, Option 2, <br/> Monday-Friday, 8AM-8PM ET</p>
      </div>
    </header>
  );
};

Header.propTypes = {
  onClick: PropTypes.func.isRequired,
  environment: PropTypes.string,
  isHome: PropTypes.bool,
};

export default Header;
